"use client";

import Link from "next/link";
import Button from "../Button";

export function CalendarNavButton({ fullWidth = false }: {
  fullWidth?: boolean;
}) {
  return (
    <Button asChild size="m" variant="tertiary" align={fullWidth ? "start" : "center"}
      className={fullWidth ? "w-full truncate" : "truncate"}>
      <Link href="/calendar">
        <Button.Text>Calendar</Button.Text>
      </Link>
    </Button>
  );
}

export default CalendarNavButton;
